import { Routes } from '@angular/router';
import {LoginComponent} from './features/auth/login/login.component';
import { EVALUATION_ROUTES } from './features/evaluation/evaluation.routes';

export const appRoutes: Routes = [
  { path: 'login', component: LoginComponent, title: 'Login' },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'library', loadChildren: () => import('./features/library/library.routes').then(m => m.LIBRARY_ROUTES) },
  { path: 'evaluation', loadChildren: () => import('./features/evaluation/evaluation.routes').then(m => m.EVALUATION_ROUTES) },
  { path: '**', redirectTo: '/login' }, // catch any not found routes and redirect to home page, or login page if not logged in
];
